<template>
  <div>
    <div class="xpage-overview-collapse">
      <a
        href="#"
        class="xcollapse-desktop"
        :class="[showDetails ? 'icon-up-open-big' : 'icon-down-open-big']"
        @click.prevent="toggleApplicationDetails()"
      ></a>
    </div>
    <div v-if="viewModel" class="xpage-overview">
      <slideDown :class="{ xhideformobile: mobileHidden }">
        <div class="xpage-overview-cols" v-show="showDetails">
          <div class="xpage-overview-cols-inner">
            <div class="xpage-overview-col" data-type="details">
              <div class="xdetails-table">
                <div class="xdetails-col-header">Application Details</div>
                <div class="xdetails-col">
                  <div class="xname">ID</div>
                  <div class="xtext">{{ viewModel?.referenceId }}</div>
                </div>
                <div class="xdetails-col">
                  <div class="xname">Created</div>
                  <div class="xtext">
                    {{ viewModel?.created }}
                  </div>
                </div>
                <div class="xdetails-col">
                  <div class="xname">Expiration</div>
                  <div class="xtext">
                    {{ viewModel?.applicationDetailsVM?.expiration }}
                  </div>
                </div>
                 <div class="xdetails-col">
                  <div class="xname">Esign Expiration</div>
                  <div class="xtext">
                    {{ viewModel?.applicationDetailsVM?.esignExpiration }}
                  </div>
                </div>
                <div class="xdetails-col">
                  <div class="xname">Concierge Requested</div>
                  <div class="xtext">
                    {{ viewModel?.applicationDetailsVM?.conciergeRequest }}
                  </div>
                </div>
                <div class="xdetails-col">
                  <div class="xname">CU Service</div>
                  <div class="xtext">
                    {{
                      viewModel?.applicationDetailsVM?.creditUnionService
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="xpage-overview-col"
              data-type="applicant"
              v-if="viewModel?.hasPrimaryApplicant"
            >
              <table>
                <tr>
                  <td colspan="2">
                    <div class="xusericon" data-size="small">
                      <div class="xusericon-picture">
                        {{ viewModel?.primaryApplicant?.initials }}
                      </div>
                      <div class="xusericon-gender" data-gender=""></div>
                    </div>
                    {{ viewModel?.primaryApplicant?.fullName }}
                    <div class="xblackpill">
                      {{ viewModel?.primaryApplicant?.applicantTypeName }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="xname">
                    {{ viewModel?.primaryApplicant?.nationalIdLabel }}
                  </td>
                  <td class="xtext">
                    {{ viewModel?.primaryApplicant?.nationalIdNumber }}
                  </td>
                </tr>
                <tr>
                  <td class="xname">Birthdate</td>
                  <td class="xtext">
                    {{ viewModel?.primaryApplicant?.birthday }}
                  </td>
                </tr>

                <tr>
                  <td class="xname">Address</td>
                  <td class="xtext" style="text-transform: capitalize">
                    {{ viewModel?.primaryApplicant?.addressDisplay }}
                  </td>
                </tr>
                <tr>
                  <td class="xname">Phone</td>
                  <td class="xtext">
                    {{ viewModel?.primaryApplicant?.phoneDisplay }}
                  </td>
                </tr>
                <tr>
                  <td class="xname">Email</td>
                  <td class="xtext">
                    {{ viewModel?.primaryApplicant?.emailAddress }}
                  </td>
                </tr>
                <tr>
                  <td class="xname">Username</td>
                  <td class="xtext">
                    {{ viewModel?.primaryApplicant?.username }}
                  </td>
                </tr>
              </table>
            </div>
            <div
              class="xpage-overview-col"
              data-type="missing-applicant"
              v-else
            >
              <div>This application is missing a Primary Applicant</div>
            </div>
            <div
              class="xpage-overview-col"
              data-type="applicant"
              v-if="viewModel?.hasCoApplicant"
            >
              <table>
                <tr>
                  <td colspan="2">
                    <div class="xusericon" data-size="small">
                      <div class="xusericon-picture">
                        {{ viewModel?.coApplicant?.initials }}
                      </div>
                      <div class="xusericon-gender" data-gender=""></div>
                    </div>
                    {{ viewModel?.coApplicant?.fullName }}
                    <div class="xblackpill">
                      {{ viewModel?.coApplicant?.applicantTypeName }}
                    </div>
                  </td>
                </tr>

                <tr>
                  <td class="xname">
                    {{ viewModel?.coApplicant?.nationalIdLabel }}
                  </td>
                  <td class="xtext">
                    {{ viewModel?.coApplicant?.nationalIdNumber }}
                  </td>
                </tr>
                <tr>
                  <td class="xname">Birthdate</td>
                  <td class="xtext">
                    {{ viewModel?.coApplicant?.birthday }}
                  </td>
                </tr>
                <tr>
                  <td class="xname">Address</td>
                  <td class="xtext" style="text-transform: capitalize">
                    {{ viewModel?.coApplicant?.addressDisplay }}
                  </td>
                </tr>
                <tr>
                  <td class="xname">Phone</td>
                  <td class="xtext">
                    {{ viewModel?.coApplicant?.phoneDisplay }}
                  </td>
                </tr>
                <tr>
                  <td class="xname">Email</td>
                  <td class="xtext">
                    {{ viewModel?.coApplicant?.emailAddress }}
                  </td>
                </tr>
                <tr>
                  <td class="xname">Username</td>
                  <td class="xtext">
                    {{ viewModel?.coApplicant?.username }}
                  </td>
                </tr>
              </table>
            </div>
            <div
              class="xpage-overview-col"
              data-type="missing-coapplicant"
              v-else
            >
              <div>This application has no Co-Applicant</div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </slideDown>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import slideDown from "@/components/SlideDown.vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import { useApplicationStore } from "@/store/store/applicationVMStore";

const applicationStore = useApplicationStore();
const { viewModel } = storeToRefs(applicationStore);

const showDetails = ref(false);
const mobileHidden = ref(false);

const route = useRoute();
const store = useStore();

// const applicantNationalIdLabel = (applicantType: string) =>
// 		(props.applicants[applicantType]?.nationalIdNumberTypeId == NationalIdNumberTypes.SSN) ?
// 		NationalIdNumberTypes[NationalIdNumberTypes.SSN] : NationalIdNumberTypes[NationalIdNumberTypes.ITIN]

const toggleApplicationDetails = () => {
  showDetails.value = !showDetails.value;
  if (localStorage.getItem("cache.applicationDetailsDisplay") == "false") {
    localStorage.setItem("cache.applicationDetailsDisplay", "true");
  } else {
    localStorage.setItem("cache.applicationDetailsDisplay", "false");
  }
};

onMounted(() => {
  if (localStorage.getItem("cache.applicationDetailsDisplay") !== "false") {
    showDetails.value = true;
  }
});
</script>

